import * as React from 'react'
import { ReactElement } from 'react'
import { Link } from 'react-router'
import ErrorPage from '../../../pages/errors/error-page'
import { RouteId } from 'core/routing/router/route-ids'
import { getPathFromRouteId } from 'core/utils/route-utils'
import Button from '@mui/material/Button'
import { withTranslation, WithTranslation } from 'react-i18next'

type ErrorInfo = { componentStack: string }

interface IProps {
  children: ReactElement
}

interface State {
  error: Error
  errorInfo: ErrorInfo
}

//there is no function component equivalent for ErrorBoundary, so we have to keep it as a class component
class ErrorBoundary extends React.Component<IProps & WithTranslation, State> {
  constructor(props: IProps & WithTranslation) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo
    })
  }

  private clearError = () => {
    this.setState({ error: null, errorInfo: null })
  }

  render(): ReactElement {
    const { children } = this.props
    const { error, errorInfo } = this.state
    if (errorInfo) {
      return (
        <ErrorPage title={this.props.t('error.description')}>
          <div>
            <Link to={getPathFromRouteId(RouteId.Home)}>
              <Button className="error-home-link" onClick={this.clearError}>
                {this.props.t('error.home')}
              </Button>
            </Link>
          </div>
          <details className="error-details">
            {error?.toString()}
            <br />
            {errorInfo.componentStack}
          </details>
        </ErrorPage>
      )
    }
    return children
  }
}

export default withTranslation()(ErrorBoundary)
